var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2LinkDeleted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#J2_Link_deleted_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 71v5l25.38-23.58c.62 0 1.24.08 1.87.08a21.09 21.09 0 0010.64-2.79 21.142 21.142 0 0010.64 2.79c10 0 18.14-6.5 18.14-14.5 0-6-4.66-11.24-11.25-13.41L76 5.52V.06L0 71zm29.81-22.68L33 45.4c.427.564.891 1.099 1.39 1.6-1.459.648-3 1.093-4.58 1.32zm8.08-3.43a11.162 11.162 0 01-2-2.21l5.46-5.06V38a9.099 9.099 0 01-3.46 6.89zM62.67 38c0 5.79-6.34 10.5-14.14 10.5A17.931 17.931 0 0141.4 47a12.81 12.81 0 004-9 11.551 11.551 0 00-.58-3.57l7.13-6.61C58.09 29 62.67 33.08 62.67 38zM9.12 38c0-8 8.13-14.5 18.13-14.5a21.089 21.089 0 0110.64 2.79A20.378 20.378 0 0145 23.78l-14.55 13.5A12.89 12.89 0 0134.39 29a17.998 17.998 0 00-7.14-1.45c-7.79 0-14.13 4.71-14.13 10.5 0 3.81 2.75 7.14 6.85 9l-3.11 2.89c-4.67-2.7-7.74-7.03-7.74-11.94z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "J2_Link_deleted_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h76v76H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/J2_Link_deleted.ed70ee9a.svg";
export { SvgJ2LinkDeleted as ReactComponent };